import { TIDClient } from '@trimble-oss/trimble-id-react';
import environment from '../../environments/environment';

export default (function () {
  return new TIDClient({
    config: {
      configurationEndpoint: environment.CONFIGURATION_ENDPOINT,
      clientId: environment.CLIENT_ID,
      redirectUrl: `${environment.TID_REDIRECT_URL}`,
      logoutRedirectUrl: `${environment.TID_LOGOUT_REDIRECT_URL}`,
      scopes: [environment.SCOPE],
    },
  });
})();
